export const getMembershipId = (currrentUser, appendMemberTitle = true) => {
  const id = currrentUser?.attributes?.profile?.publicData?.membershipId;
  return id ? (!appendMemberTitle ? id : `Member: ${id}`) : '';
};
